import type { TRuleWithTheme } from '@ackee/fela';

export const link: TRuleWithTheme = ({ theme: { colors, transition, fonts } }) => ({
    ...fonts.heroNewBold,
    color: colors.blue,
    fontSize: '1.25rem',
    display: 'inline-block',

    textDecoration: 'none',

    borderBottom: `2px solid ${colors.blue}`,
    marginBottom: '2.5rem',

    transition,
    transitionProperty: 'color',

    ':hover': {
        color: colors.fuchsia,
    },
});
